import { IBudgetApiPayload, IBudgetService, IClientData, IVehicleData } from '../types';
import { calculateBudgetTotals, parseHourMeter, parseNumber } from './budgetCalculations';

interface IBuildApiPayloadParams {
  occurrenceId: string;
  recipient: string | undefined;
  clientData: IClientData | undefined;
  vehicleData: IVehicleData | undefined;
  services: IBudgetService[];
  proposalServices?: IBudgetService[];
}

export const buildBudgetApiPayload = (params: IBuildApiPayloadParams): IBudgetApiPayload => {
  const { occurrenceId, recipient, clientData, vehicleData, services, proposalServices } = params;

  const {
    services: mappedServices,
    subtotal,
    discount,
    netTotal,
  } = calculateBudgetTotals(services);

  let mappedProposalServices: IBudgetApiPayload['proposalServices'] = undefined;
  if (proposalServices && proposalServices.length > 0) {
    const calculated = calculateBudgetTotals(proposalServices);
    mappedProposalServices = calculated.services;
  }

  const payload: IBudgetApiPayload = {
    occurrenceProtocolNumber: vehicleData?.protocolNumber || '',
    occurrenceUuid: occurrenceId,
    recipient: recipient || '',

    customer: {
      name: clientData?.name || '',
      email: clientData?.email || '',
      phone: clientData?.phone || '',
    },

    vehicle: {
      chassis: vehicleData?.chassis,
      licensePlate: vehicleData?.licensePlate?.slice(0, 20),
      year: parseNumber(vehicleData?.year),
      model: vehicleData?.model,
      odometer: parseNumber(vehicleData?.odometer?.replaceAll(/[^\d]/g, '')),
      hourMeter: parseHourMeter(vehicleData?.hourmeter),
      contractNumber: vehicleData?.contractNumber || null,
    },

    services: mappedServices,
    proposalServices: mappedProposalServices,
    subtotal,
    discount,
    netTotal,
    observation: undefined,
  };

  return payload;
};
